import { useEffect } from 'react';

// Norme Happn : le point orange est posé par le CSS (::after). Si un titre finit déjà par « . », on retire ce point du texte.
const SEL = '.app-da h1, .app-da h2, .app-da h3, .app-da h4, .home-da h1, .home-da h2, .home-da h3, .home-da h4, .app-da .sab-title, .app-da .act-title, .app-da .hp-card-title, .app-da .da-article-title, .app-da .fin-moment-title, .app-da .stb-title, [role="dialog"] h2';
const SKIP = '.hh-title, .app-module-title, .mm-title, .da-hand, [data-nodot]';

const strip = (root) => {
  root.querySelectorAll(SEL).forEach((el) => {
    if (el.matches(SKIP) || el.querySelector('.dot, .app-module-dot')) return;
    let node = el.lastChild;
    while (node && node.nodeType !== Node.TEXT_NODE && node.lastChild) node = node.lastChild;
    if (!node || node.nodeType !== Node.TEXT_NODE) return;
    const t = node.textContent;
    if (t.trim() === '.') { node.textContent = ''; return; }
    const m = /^(.*?[^.\s])\.\s*$/.exec(t);
    if (m && !t.trim().endsWith('…') && !/\.\.\s*$/.test(t)) node.textContent = m[1];
  });
};

export const useTitleDots = () => {
  useEffect(() => {
    let raf = 0;
    const run = () => { raf = 0; strip(document.body); };
    run();
    const obs = new MutationObserver(() => { if (!raf) raf = requestAnimationFrame(run); });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => { obs.disconnect(); if (raf) cancelAnimationFrame(raf); };
  }, []);
};
